import React, { memo, useCallback } from 'react'
import IconButton from '../common/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

type Props = {
  prompt: string;
  onPromptChange?: React.ChangeEventHandler<HTMLInputElement>;
  onSendMessage?: Function;
}

function ChatInput({ prompt, onPromptChange, onSendMessage }: Props) {

  const handleSendMessage = useCallback((evt: React.MouseEvent<HTMLButtonElement> | React.FormEvent<HTMLFormElement>) => {
    evt.stopPropagation?.();
    evt.preventDefault?.();
    onSendMessage?.(prompt);
  }, [prompt, onSendMessage]);

  return (
    <div className="chat-input-wrapper">
      <form onSubmit={handleSendMessage}>
        <input
          className="chat-input"
          placeholder="Type message here..."
          value={prompt}
          onChange={onPromptChange}
          autoFocus
        />

        <IconButton
          type="submit"
          disabled={!prompt.length}
          className="chat-input-submit"
          tooltip="Send Message"
          onClick={handleSendMessage}
        >
          <FontAwesomeIcon icon={solid('arrow-alt-circle-up')} size="lg" />
        </IconButton>
      </form>
    </div>
  )
}

export default memo(ChatInput);